<p-table
  [value]="dataRows"
  [lazy]="lazy"
  (onLazyLoad)="loadData($event)"
  [columns]="cols"
  [rows]="rows"
  [rowsPerPageOptions]="rowsPerPageOptions"
  [totalRecords]="totalRecords"
  [loading]="loading"
  [(first)]="firstRow"
  [sortMode]="'multiple'"
  [paginator]="!noPagination"
  [showCurrentPageReport]="true"
  currentPageReportTemplate="{first} - {last} {{'label.common.pagination.page-on-pages' | translate }} {totalRecords}"
  [(selection)]="selectedRows"
  [multiSortMeta]="multiSortMeta"
  (onFilter)="broadCastFirstPage()"
  (onSort)="broadCastFirstPage()"
  (onPage)="onPageChange($event)"
  (onRowSelect)="onRowSelectionUpdate()"
  (onRowUnselect)="onRowSelectionUpdate()"
  (onEditComplete)="emitInputCellEditFinish($event)"
  [selectionPageOnly]="true"
  [stateStorage]="'local'" stateKey="{{ getStateKey() }}"
  styleClass="neq-primeng-table">
  <ng-template pTemplate="header" let-columns>
    <tr>
      <th *ngIf="selectableRows || nutrients" class="primeng-table-center-cell select-all-col" scope="col">
        <p-tableHeaderCheckbox (click)="onRowSelectionUpdate()" (keyDown)="onRowSelectionUpdate()"></p-tableHeaderCheckbox>
      </th>
      <ng-container *ngFor="let col of columns">
        <th
          class="{{returnCellDataPositionClass(col.position)}}"
          [style]="returnThColStyle(col)"
          *ngIf="showCol(col)"
          [pSortableColumn]="returnEffectiveFieldName(col)"
          [pSortableColumnDisabled]="!isSortable(col)"
        >
          <div class="header-div">
            <div class="header-element" style="padding-right: 3px;" *ngIf="col.checkAll">
              <mat-checkbox
                [disabled]="!isImportOrOverrideAllEnabled(col)"
                [checked]="areAllCheckboxesChecked(col)"
                (click)="changeAllCheckboxesState($event, col)"
                (keyDown)="changeAllCheckboxesState($event, col)">
              </mat-checkbox>
            </div>
            <div class="header-element" *ngIf="!col.iconHeaderClassName">
              {{col.header | translate}}
            </div>
            <div class="header-element" *ngIf="col.iconHeaderClassName">
              <i class="{{col.iconHeaderClassName}}" matTooltip="{{col.header | translate}}"></i>
            </div>
            <div class="header-element">
              <p-sortIcon *ngIf="isSortable(col)"
                          [field]="returnEffectiveFieldName(col)">
              </p-sortIcon>
              <ng-container *ngIf="hasAllDynamicValue() && col.dynamicValue">
                <span [matTooltip]="getHeaderTooltip(col.dynamicValue, col.field)">
                  {{ col.dynamicValue.code }}
                </span>
                &nbsp;
                <i
                  class="fas fa-trash-alt cursor-pointer"
                  *ngIf="!dynamicRequirements.parentPredictionModel && !dynamicRequirements.parentVariable"
                  (click)="deleteColumn(col.dynamicValue)"
                  (keyDown)="deleteColumn(col.dynamicValue)"
                  [matTooltip]="'msg.common.icon.column.delete' | translate"></i>
              </ng-container>

              <ng-container *ngIf="col.isDeletable">
                &nbsp;
                <i class="fas fa-trash-alt cursor-pointer"
                   (click)="deleteColumn(col.field)"
                   (keyDown)="deleteColumn(col.field)"
                   [matTooltip]="'msg.common.icon.column.delete' | translate"></i>
              </ng-container>

              <ng-container *ngIf="col.canBeMassEdit">
                &nbsp;
                <i class="fas fa-edit cursor-pointer"
                   [matTooltip]="'msg.common.icon.column.multiEdit' | translate"
                   (click)="massEditColumn(col)"
                   (keyDown)="massEditColumn(col)"></i>
              </ng-container>

              <ng-container
                *ngIf="activeFilter && (col.filterable === true || col.filterable === undefined)">
                <!-- Text Filter -->
                <ng-container *ngIf="col.type !== 'date' && !col.filterOptions && !isColForExtendedAction(col)">
                  <p-columnFilter
                    #dtft
                    (click)="onShowFilter(col)"
                    (keyDown)="onShowFilter(col)"
                    type="{{ returnFilterConf(col, 'type') }}"
                    field="{{ returnEffectiveFieldName(col) }}"
                    [matchMode]="returnFilterConf(col, 'matchMode')"
                    [showMatchModes]="false"
                    [showAddButton]="false"
                    [showOperator]="false"
                    [showApplyButton]="false"
                    [showClearButton]="false"
                    display="menu">
                    <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                      <input
                        id="{{getFilterId(col)}}"
                        (keydown.enter)="applyTextFilterValue(inputFormModel, filter, dtft)"
                        type="text"
                        pInputText
                        [ngModel]="value"
                        #inputFormModel="ngModel"
                      >
                      <div class="table-column-filter-buttonbar">
                        <button pButton (click)="clearTextFilter(dtft)" label="Clear" class="filter-button p-element p-button-outlined p-button-sm">
                        </button>
                        <button pButton label="Apply" (click)="applyTextFilterValue(inputFormModel, filter, dtft)" class="filter-button p-element p-button-sm">
                        </button>
                      </div>
                    </ng-template>
                  </p-columnFilter>
                </ng-container>
                <!-- Select Filter -->
                <ng-container *ngIf="col.type !== 'date' && col.filterOptions">
                  <neq-primeng-table-select-filter
                    field="{{returnEffectiveFieldName(col)}}"
                    [col]="col"
                    [filterOptions]="col.filterOptions"
                  ></neq-primeng-table-select-filter>
                </ng-container>
                <!-- Date Filter -->
                <ng-container *ngIf="col.type === 'date'">
                  <neq-primeng-table-date-filter field="{{ returnEffectiveFieldName(col) }}" [sessionId]="sessionId">
                  </neq-primeng-table-date-filter>
                </ng-container>
              </ng-container>
            </div>
          </div>
        </th>
      </ng-container>
      <th *ngIf="actions">
        <div>
          ACTIONS
        </div>
      </th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-rowData let-columns="columns" let-index="rowIndex">
    <tr class="{{ returnRowClass(rowData) }}">
      <td *ngIf="selectableRows" class="primeng-table-center-cell select-all-col">
        <p-checkbox [disabled]="true" *ngIf="disableSelectableCheckboxCell(rowData)"></p-checkbox>
        <p-tableCheckbox [value]="rowData" *ngIf="!disableSelectableCheckboxCell(rowData)"></p-tableCheckbox>
      </td>
      <ng-container *ngFor="let col of columns">
        <ng-container *ngIf="showCol(col)">
          <ng-container *ngIf="isColForFieldOnly(col)">
            <td class="{{returnCellClass(col, rowData)}}" [style]="returnTdColStyle(col)">
              {{returnColDataToDisplay(col, rowData)}}
            </td>
          </ng-container>

          <ng-container *ngIf="isColForOtherTypes(col)">
            <td class="{{returnCellClass(col, rowData)}}" [style]="returnTdColStyle(col)">
              <neq-primeng-table-cell-types
                [col]="col"
                [rowData]="rowData"
                (checkCellEmitter)="emitCheckCell($event)">
              </neq-primeng-table-cell-types>
            </td>
          </ng-container>

          <ng-container *ngIf="isColForInput(col)">
            <td class="{{returnCellClass(col, rowData)}}" [style]="returnTdColStyle(col)"
                [pEditableColumn]="rowData" [pEditableColumnField]="col"
            >
              <neq-primeng-table-cell-inputs-variable
                [col]="col"
                [numberDynamicColumn]="numberDynamicColumn"
                [dynamicRequirements]="dynamicRequirements"
                [rowData]="rowData">
              </neq-primeng-table-cell-inputs-variable>
            </td>
          </ng-container>

          <ng-container *ngIf="isColForExtendedAction(col)">
            <td class="{{returnCellClass(col, rowData)}}" [style]="returnTdColStyle(col)">
              <div>
                <ng-container *ngFor="let actionCol of col.actions">
                  <neq-icon class="{{ actionCol.class || '' }}"
                            [class.disabled]="disableExtendedAction(rowData, actionCol)"
                            *ngIf="showExtendedAction(rowData, actionCol)"
                            [disabled]="disableExtendedAction(rowData, actionCol)"
                            svgIcon="{{actionCol.svgIcon}}"
                            (click)="action(rowData, actionCol.type)"
                            (keyDown)="action(rowData, actionCol.type)"
                            [matTooltip]="actionCol.tooltip | translate"></neq-icon>
                </ng-container>
              </div>
            </td>
          </ng-container>

          <ng-container *ngIf="isColForRawMaterialsEdit(col)">
            <td class="{{returnCellClass(col, rowData)}}" [style]="returnTdColStyle(col)"
                [pEditableColumn]="rowData" [pEditableColumnField]="col">
              <neq-primeng-table-cell-inputs-rawmaterial
                [col]="col"
                [rowData]="rowData"
                (changeDataEmitter)="changeDataEvent($event)"
                [eventDataChecked]="eventDataChecked"
                [initalRawMaterialsData]="initalRawMaterialsData"
                [nutrientsData]="nutrientsData"
                [initNutrientsData]="initNutrientsData">
              </neq-primeng-table-cell-inputs-rawmaterial>
            </td>
          </ng-container>
        </ng-container>
      </ng-container>

      <!-- Actions for the Rawmaterial table on the home of MatrixNutri user -->
      <td *ngIf="actions && actions === 'user'" >
        <div>
          <neq-icon class="action important" svgIcon="editer" (click)="action(rowData, staticEditAction)" (keyDown)="action(rowData, staticEditAction)"
                    [matTooltip]="'msg.common.icon.rawmaterial.input' | translate"></neq-icon>
          <ng-container *ngIf="canBeDuplicated(rowData)">
            <neq-icon class="action important" svgIcon="copy" (click)="action(rowData, staticDuplicateAction)" (keyDown)="action(rowData, staticDuplicateAction)"
                      *hasRights="duplicateRight"
                      [matTooltip]="'msg.common.icon.rawmaterial.duplicate' | translate"
            ></neq-icon>
          </ng-container>
          <ng-container *ngIf="isEnabled(rowData)">
            <neq-icon class="action" fxFlexAlign="end" svgIcon="activer" (click)="action(rowData, staticDisableAction)" (keyDown)="action(rowData, staticDisableAction)"
                      [matTooltip]="'msg.common.icon.rawmaterial.disable' | translate"
                      *hasRights="enableDisableRight"></neq-icon>
          </ng-container>
          <ng-container *ngIf="canBeEnabled(rowData)">
            <neq-icon class="action" fxFlexAlign="end" svgIcon="desactiver" (click)="action(rowData, staticEnableAction)" (keyDown)="action(rowData, staticEnableAction)"
                      [matTooltip]="'msg.common.icon.rawmaterial.enable' | translate"
                      *hasRights="enableDisableRight"></neq-icon>
          </ng-container>
          <ng-container *ngIf="!isArchived(rowData)">
            <neq-icon class="action" fxFlexAlign="end" svgIcon="archiver" (click)="action(rowData, staticArchiveAction)" (keyDown)="action(rowData, staticArchiveAction)"
                      [matTooltip]="'msg.common.icon.rawmaterial.archive' | translate"
                      *hasRights="archiveRight"></neq-icon>
          </ng-container>
          <ng-container *ngIf="isArchived(rowData)">
            <neq-icon class="action" fxFlexAlign="end" svgIcon="desarchiver" (click)="action(rowData, staticDesarchiveAction)" (keyDown)="action(rowData, staticDesarchiveAction)"
                      [matTooltip]="'msg.common.icon.rawmaterial.desarchive' | translate"
                      *hasRights="desarchiveRight"></neq-icon>
          </ng-container>
          <ng-container *ngIf="canBeDeleted(rowData)">
            <neq-icon class="action" svgIcon="corbeille" (click)="action(rowData, staticDeleteAction)" (keyDown)="action(rowData, staticDeleteAction)"
                      [matTooltip]="'msg.common.icon.rawmaterial.delete' | translate"
                      *hasRights="deleteRight"></neq-icon>
          </ng-container>
        </div>
      </td>
      <td *ngIf="actions && actions !== 'user'" class="row">
        <div>
          <ng-container *ngIf="getRightAction('edit')">
            <neq-icon class="action important" svgIcon="editer" (click)="action(rowData, staticEditAction)" (keyDown)="action(rowData, staticEditAction)"
                      *hasRights="adminRight['edit']"
                      [matTooltip]="getRightAction('edit').tooltip | translate"></neq-icon>
          </ng-container>
          <ng-container *ngIf="getRightAction('goUp') && !isFirst(index)">
            <neq-icon class="action" fxFlexAlign="end" svgIcon="chevron-haut" (click)="action(rowData, staticGoUpAction)" (keyDown)="action(rowData, staticGoUpAction)"
                      *hasRights="adminRight['equation']"></neq-icon>
          </ng-container>
          <ng-container *ngIf="getRightAction('goDown') && !isLast(index)">
            <neq-icon class="action" fxFlexAlign="end" svgIcon="chevron-bas" (click)="action(rowData, staticGoDownAction)" (keyDown)="action(rowData, staticGoDownAction)"
                      *hasRights="adminRight['equation']"></neq-icon>
          </ng-container>
          <ng-container *ngIf="getRightAction('equation')">
            <neq-icon class="action" fxFlexAlign="end" svgIcon="predicteur" (click)="action(rowData, staticEquationAction)" (keyDown)="action(rowData, staticEquationAction)"
                      *hasRights="adminRight['equation']"
                      [matTooltip]="getRightAction('equation').tooltip | translate"></neq-icon>
          </ng-container>
          <ng-container *ngIf="getRightAction('nutrient')">
            <neq-icon class="action" fxFlexAlign="end" svgIcon="connecter" (click)="action(rowData, staticNutrientAction)" (keyDown)="action(rowData, staticNutrientAction)"
                      *hasRights="adminRight['nutrient']"
                      [matTooltip]="getRightAction('nutrient').tooltip | translate"></neq-icon>
          </ng-container>
          <ng-container *ngIf="getRightAction('value')">
            <neq-icon class="action" fxFlexAlign="end" svgIcon="calcul" (click)="action(rowData, staticValueAction)" (keyDown)="action(rowData, staticValueAction)"
                      *hasRights="adminRight['value']"
                      [matTooltip]="getRightAction('value').tooltip | translate"></neq-icon>
          </ng-container>
          <ng-container *ngIf="getRightAction('extend')">
            <neq-icon *ngIf="!isSuperAdmin(rowData)" class="action" svgIcon="ajout_date" (click)="action(rowData, staticExtendAction)" (keyDown)="action(rowData, staticExtendAction)"
                      [matTooltip]="'msg.common.icon.user.incrementDate' | translate"></neq-icon>
          </ng-container>
          <ng-container *ngIf="getRightAction('delete')">
            <neq-icon class="action" fxFlexAlign="end" svgIcon="corbeille" (click)="action(rowData, staticDeleteAction)" (keyDown)="action(rowData, staticDeleteAction)"
                      *hasRights="adminRight['delete']"
                      [matTooltip]="getRightAction('delete').tooltip | translate"></neq-icon>
          </ng-container>
        </div>
      </td>
    </tr>
  </ng-template>
</p-table>
